// context/QuizContext.js
import React, { createContext, useContext, useReducer } from 'react';

const QuizContext = createContext();

const initialState = {
  studentInfo: null,
  warnings: 0,
  currentQuestion: 0,
  answers: [],
  startTime: null,
  endTime: null,
  score: 0,
  cameraActive: false,
  quizCompleted: false
};

function quizReducer(state, action) {
  switch (action.type) {
    case 'SET_STUDENT_INFO':
      return { ...state, studentInfo: action.payload };
    case 'ADD_WARNING':
      return { ...state, warnings: state.warnings + 1 };
    case 'SET_CURRENT_QUESTION':
      return { ...state, currentQuestion: action.payload };
    case 'SET_ANSWER':
      const answers = [...state.answers];
      answers[state.currentQuestion] = action.payload;
      return { ...state, answers };
    case 'START_QUIZ':
      return { ...state, startTime: new Date(), cameraActive: true };
    case 'END_QUIZ':
      return { 
        ...state, 
        endTime: new Date(), 
        quizCompleted: true,
        cameraActive: false 
      };
    case 'SET_SCORE':
      return { ...state, score: action.payload };
    case 'SET_CAMERA_STATUS':
      return { ...state, cameraActive: action.payload };
    case 'RESET_QUIZ':
      return initialState;
    default:
      return state;
  }
}

export function QuizProvider({ children }) {
  const [state, dispatch] = useReducer(quizReducer, initialState);

  return (
    <QuizContext.Provider value={{ state, dispatch }}>
      {children}
    </QuizContext.Provider>
  );
}

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuiz must be used within a QuizProvider');
  }
  return context;
};